/* eslint-disable max-lines */
import './App.css';
import {
    Routes, Route, Navigate, useParams, useLocation
} from 'react-router-dom';
import Login from './app/routing/login';
import Signup from './app/routing/signup';
import Profile from './app/routing/profile';
import NotFound from './app/routing/notFound';
import Organization from './app/routing/organizations';
import OrganizationSetting from './app/routing/organizations/settings';
import OrganizationMembers from './app/routing/organizations/members';
import SubOrganizations from './app/routing/organizations/sub';
import StudioPicker from './app/routing/organizations/studioPicker';
import {
    AuthRoute
} from 'app/layout/AuthRoutes';
import {
    ProtectedOrgRoute
} from 'app/layout/ProtectedOrgRoutes';
import {
    ProtectedSubOrgRoute
} from 'app/layout/ProtectedSubOrgRoute';
import VerifyEmail from './app/routing/verifyEmail';
import ResetPassword from './app/routing/resetPassword';
import ChangePassword from './app/routing/changePassword';
import ForceChangePassword from './app/routing/forceChangePassword';
import {
    Layout
} from 'app/layout/Wrapper';
import SideMenuWrapper from 'app/layout/SideMenuWrapper';
import mainSectionMenu from './shared/data/mainSectionMenu';
import orgSectionMenu from './shared/data/orgSectionMenu';
import SubOrganizationSettings from './app/routing/organizations/subOrganization/settings';
import OpCodes from 'app/routing/organizations/subOrganization/builderOpcode';
import Channels from 'app/routing/organizations/subOrganization/builderChannel';
import Assistants from 'app/routing/organizations/subOrganization/builderAssistant';
import {
    SubOrganizationProvider
} from 'shared/context/SubOrganizationContext';
import {
    OrganizationProvider
} from 'shared/context/OrganizationContext';
import KnowledgeBuilder from 'app/routing/organizations/subOrganization/builderKnowledge';
import RedirectUser from 'app/routing/redirectUser';
import OpCodeWrapper from 'builders/builderOpcode/OpCodeWrapper';
import JsonOpcodeCreate from 'builders/builderOpcode/jsonMode/JsonOpcodeCreate';
import JsonOpcodeUpdate from 'builders/builderOpcode/jsonMode/JsonOpcodeUpdate';
import JsonOpcodeViewAndExecute from 'builders/builderOpcode/jsonMode/JsonOpcodeViewAndExecute';
import V2OpCodeBuilderPage from 'builders/builderOpcode/configMode/v2/V2OpCodeBuilderPage';
import LivePrompt from 'builders/builderInternal/components/LivePrompt';
import ApiManager from 'builders/builderInternal/components/ApiManager';
import MCPManager from 'builders/builderInternal/components/MCPManager';
import Instructions from 'builders/builderInternal/components/Instructions';
import CodeSandbox from 'builders/builderInternal/components/CodeSandbox';
import AITeacher from 'builders/builderInternal/components/AITeacher';
import TuningExperiment from 'builders/builderInternal/components/TuningLab';
import ChannelDetails from 'builders/builderChannel/components/ChannelDetails';
import InstructionDetails from 'builders/builderInternal/components/Instructions/InstructionDetails';
import AiLab from 'app/routing/organizations/subOrganization/aiLab';

// Legacy App Builder (restored) — org-scoped app builder at /app-builder
import AppBuilderPage from 'app/routing/organizations/subOrganization/builderApp';
import {
    ManageApp
} from 'builders/builderApp/ManageApp';
import DataBuilderPage from 'builders/builderApp/DataBuilder';
import {
    PageBuilderTab
} from 'builders/builderApp/3dBuilder/PageBuilderTab';
import AppInfo from 'builders/builderApp/AppInfo';
import DataBuilderDashboard from 'builders/builderApp/DataBuilder/DataBuilder';
import Tables from 'builders/builderApp/DataBuilder/Tables';
import PageBuilderPage from 'builders/builderApp/3dBuilder';
import ProjectPage from 'builders/builderApp/3dBuilder/PageBuilder';
import {
    CreateTableAIPage
} from 'builders/builderApp/DataBuilder/Tables/components/CreateTableAI';
import {
    DashboardView
} from 'builders/builderApp/DataBuilder/Tables/components/DashboardView';
import {
    BlueprintsPage
} from 'builders/builderApp/DataBuilder/Tables/components/Blueprints';
import {
    TableViewSelector
} from 'builders/builderApp/DataBuilder/Tables/components/TableViewSelector';
import ConnectionHome from 'builders/builderApp/Connection';
import {
    ConnectionFormPage
} from 'builders/builderApp/Connection/ConnectionFormPage';
import DataBuilderV2Layout from 'builders/builderApp/DataBuilder/v2/DataBuilderV2Layout';
import DashboardV2 from 'builders/builderApp/DataBuilder/v2/components/DashboardV2';
import ConnectionsPage from 'builders/builderApp/DataBuilder/v2/pages/ConnectionsPage';
import WorkflowsPage from 'builders/builderApp/DataBuilder/v2/pages/WorkflowsPage';
import TriggersPage from 'builders/builderApp/DataBuilder/v2/pages/TriggersPage';
import SecurityPage from 'builders/builderApp/DataBuilder/v2/pages/SecurityPage';
import ApiKeysPage from 'builders/builderApp/DataBuilder/v2/pages/ApiKeysPage';
import SettingsPageV2 from 'builders/builderApp/DataBuilder/v2/pages/SettingsPage';

import InstructionVnV from 'builders/builderInternal/components/V&V/V&V';
import {
    ProtectedRoute
} from 'app/layout/ProtectedRoutes';
import {
    AppErrorBoundary
} from 'shared/components/ErrorBoundary';

// DE Studio (A-0012.02 — new builder shell behind feature flag)
import {
    DE_STUDIO_ENABLED
} from 'builders/destudio/config/featureFlags';
import DEStudioShell from 'builders/destudio/DEStudioShell';
import UnifiedBuilder from 'builders/destudio/unified-builder/UnifiedBuilder';
import AssistantWorkspace from 'builders/destudio/unified-builder/AssistantWorkspace';
import LibraryPage from 'builders/destudio/pages/LibraryPage';
import LibraryOpcodeRedirect from 'builders/destudio/library/LibraryOpcodeRedirect';
import ActivityPage from 'builders/destudio/pages/ActivityPage';
import UsagePage from 'builders/destudio/pages/UsagePage';

import KBFileManager from 'builders/builderKnowledge/KBFileManager';
import AssistantDetails from './builders/builderAssistant/configMode/AssistantDetails';
import AiLabWrapper from 'builders/builderInternal/configMode/Page';
import AppStudioRoutes from 'builders/appStudio/AppStudioRoutes';
import GuideScreen from 'builders/appStudio/screens/guide/GuideScreen';
import {
    APP_STUDIO_ENABLED
} from 'shared/config/featureFlags';
import {
    PERMISSIONS
} from 'shared/context/permissions';
import RequireAccess from 'shared/context/RequireAccess';
import IntegrationsPage from 'app/routing/organizations/configurations/configPage';
import ConfigurationDetails from 'app/routing/organizations/configurations/ConfigurationDetails';
import ProvisionedConfig from 'features/provisioned-config';
import ProvisionedConfigAuth from 'features/provisioned-config/ProvisionedConfigAuth';

function LibraryCollectionsRedirect() {
    const {
        oragID, subOragID
    } = useParams();
    return <Navigate to={`/organizations/${oragID}/sub/${subOragID}/de-studio/library?tab=collections`} replace />;
}

// Back-compat redirect for the short-lived /app-studio namespace — the App
// Studio module now IS the 3D App Studio and lives under /3dapp-studio.
function AppStudioRedirect() {
    const {
        pathname, search, hash
    } = useLocation();
    const target = pathname.replace('/app-studio', '/3dapp-studio');
    return <Navigate to={`${target}${search}${hash}`} replace />;
}

// When the new 3D App Studio is disabled (REACT_APP_ENABLE_APP_STUDIO=false, i.e.
// staging + production) any /3dapp-studio* URL redirects to the org root. The
// legacy /app-builder is unaffected.
function AppStudioDisabledRedirect() {
    const {
        oragID
    } = useParams();
    return <Navigate to={`/organizations/${oragID}`} replace />;
}

function App() {
    return (
        <Routes>
            <Route path="/" element={<Navigate to={'/auth/login'} />} />

            {/* Public routes — no login required */}
            <Route path="/provisioned-config/auth" element={<ProvisionedConfigAuth />} />
            <Route path="/provisioned-config" element={<ProvisionedConfig />} />
            <Route element={<Layout />}>
                <Route element={<AuthRoute />}>
                    <Route path="/auth">
                        <Route index path="login" element={<Login />} />
                        <Route path="signup" element={<Signup />} />
                        <Route path="reset-password" element={<ResetPassword />} />
                    </Route>
                </Route>
            </Route>
            <Route path="/auth/change-password/:token" element={<ChangePassword />} />
            <Route path="/auth/force-change-password" element={<Layout />}>
                <Route index element={<ForceChangePassword />} />
            </Route>

            <Route element={<Layout />}>
                <Route element={<ProtectedRoute />}>
                    {/* used to redirect user on login */}
                    <Route path="redirect" element={<RedirectUser />} />

                    <Route element={<SideMenuWrapper section={mainSectionMenu} />}>
                        <Route path="profile" element={<Profile />} />
                        <Route path="organizations" element={<Organization />} />
                    </Route>

                    <Route element={<ProtectedRoute />}>
                        <Route path="organizations/:oragID">
                            <Route
                                element={
                                    <OrganizationProvider>
                                        <ProtectedOrgRoute />
                                    </OrganizationProvider>
                                }
                            >
                                <Route element={<SideMenuWrapper section={orgSectionMenu} />}>
                                    <Route index element={<StudioPicker />} />
                                    <Route path="sub" element={<SubOrganizations />} />
                                    <Route path="members" element={
                                        <RequireAccess permission={PERMISSIONS.VIEW_ORGANIZATION_MEMBERS}>
                                            <OrganizationMembers />
                                        </RequireAccess>
                                    } />
                                    {/* redirect configurations page to integrations (works as fallback) */}
                                    <Route path="configurations" element={<Navigate to="../integrations" />} />
                                    <Route path="integrations">
                                        <Route index element={
                                            <RequireAccess permission={PERMISSIONS.VIEW_ORGANIZATION_INTEGRATION}>
                                                <IntegrationsPage />
                                            </RequireAccess>
                                        } />
                                        <Route
                                            path=":configId"
                                            element={
                                                <RequireAccess permission={PERMISSIONS.VIEW_ORGANIZATION_INTEGRATION}>
                                                    <ConfigurationDetails />
                                                </RequireAccess>
                                            }
                                        />
                                    </Route>
                                    <Route path="settings" element={<OrganizationSetting />} />
                                </Route>

                                {/* 3D App Studio — org-scoped (no sub-org). Gated by
                                    APP_STUDIO_ENABLED: hidden on staging + production (flag off),
                                    visible in dev. The legacy /app-builder below is unaffected.
                                    When disabled, all /3dapp-studio* + /app-studio URLs redirect
                                    to the org root. */}
                                {APP_STUDIO_ENABLED ? (
                                    <>
                                        <Route path="3dapp-studio/*" element={<AppStudioRoutes />} />
                                        {/* Learn is APP-LEVEL (global guide/catalog, no app context).
                                            A STATIC segment outranks the legacy /3dapp-studio/:appId
                                            below, so "learn" isn't mistaken for an app id. */}
                                        <Route path="3dapp-studio/guide" element={<GuideScreen />} />
                                        <Route path="3dapp-studio/learn" element={<GuideScreen />} />
                                        {/* Back-compat: /app-studio URLs → /3dapp-studio */}
                                        <Route path="app-studio/*" element={<AppStudioRedirect />} />
                                    </>
                                ) : (
                                    <>
                                        <Route path="3dapp-studio/*" element={<AppStudioDisabledRedirect />} />
                                        <Route path="app-studio/*" element={<AppStudioDisabledRedirect />} />
                                    </>
                                )}

                                {/* Legacy App Builder — org-scoped (no sub-org). Restored
                                    alongside the new App Studio so staging apps can still be
                                    managed via the old builder. Structure mirrors the historical
                                    3dapp-studio block; only the top-level path is renamed. */}
                                <Route path="app-builder">
                                    <Route index element={<AppBuilderPage />} />
                                    <Route path=":appId" element={<ManageApp />}>
                                        <Route path="manage-app" element={<AppInfo />} />
                                        <Route
                                            path="data-builder"
                                            element={<DataBuilderPage />}
                                        >
                                            <Route index element={<DataBuilderDashboard />} />
                                        </Route>
                                        <Route
                                            path="story-builder"
                                            element={<PageBuilderPage />}
                                        >
                                            <Route index element={<PageBuilderTab />} />
                                        </Route>
                                    </Route>
                                    <Route
                                        path=":appId/data-builder/tables"
                                        element={<Tables />}
                                    >
                                        <Route index element={<DashboardView />} />
                                        <Route
                                            path="create-table-ai"
                                            element={<CreateTableAIPage />}
                                        />
                                        <Route path="blueprints" element={<BlueprintsPage />} />

                                        <Route
                                            path=":tableId"
                                            element={<TableViewSelector />}
                                        />
                                    </Route>
                                    <Route
                                        path=":appId/data-builder/connection-configuration"
                                        element={<ConnectionHome />}
                                    />
                                    <Route
                                        path=":appId/data-builder/connection-configuration/new"
                                        element={<ConnectionFormPage />}
                                    />
                                    <Route
                                        path=":appId/story-builder/page-builder"
                                        element={<ProjectPage />}
                                    />
                                    <Route path=":appId/data-builder-v2" element={<DataBuilderV2Layout />}>
                                        <Route index element={<DashboardV2 />} />
                                        <Route path="connections" element={<ConnectionsPage />} />
                                        <Route path="workflows" element={<WorkflowsPage />} />
                                        <Route path="triggers" element={<TriggersPage />} />
                                        <Route path="security" element={<SecurityPage />} />
                                        <Route path="api-keys" element={<ApiKeysPage />} />
                                        <Route path="settings" element={<SettingsPageV2 />} />
                                    </Route>
                                </Route>

                                <Route path="sub/:subOragID">
                                    <Route
                                        element={
                                            <SubOrganizationProvider>
                                                <ProtectedSubOrgRoute />
                                            </SubOrganizationProvider>
                                        }
                                    >
                                        <Route
                                            index
                                            element={
                                                <Navigate to={DE_STUDIO_ENABLED ? 'de-studio' : 'ai-lab'} replace />
                                            }
                                        />
                                        {/* Assistant Builder */}
                                        <Route path="assistants">
                                            <Route index element={<Assistants />} />
                                            <Route
                                                path=":assistantId"
                                                element={<AssistantDetails />}
                                            />
                                        </Route>
                                        {/* Knowledge Builder */}
                                        <Route path="knowledge-builder">
                                            <Route index element={<KnowledgeBuilder />} />
                                            <Route path=":collectionId">
                                                <Route index element={<Navigate to=".." replace />} />
                                                <Route
                                                    path=":fileName"
                                                    element={<KBFileManager />}
                                                ></Route>
                                            </Route>
                                        </Route>
                                        {/* Opcode Builder */}
                                        <Route path="op-codes" element={<OpCodeWrapper />}>
                                            <Route index element={<OpCodes />} />
                                            <Route
                                                path="classic"
                                                element={<OpCodes defaultTab="classic" />}
                                            />
                                            <Route
                                                path="json"
                                                element={<OpCodes defaultTab="json" />}
                                            />
                                            <Route
                                                path="json/create"
                                                element={<JsonOpcodeCreate />}
                                            />
                                            <Route
                                                path="json/:opcodeId"
                                                element={<JsonOpcodeUpdate />}
                                            />
                                            <Route
                                                path="json/:opcodeId/execute"
                                                element={<JsonOpcodeViewAndExecute />}
                                            />
                                            <Route
                                                path="v2/create"
                                                element={<V2OpCodeBuilderPage />}
                                            />
                                            <Route
                                                path="v2/:opcodeId"
                                                element={<V2OpCodeBuilderPage />}
                                            />
                                            <Route
                                                path=":opCodeName"
                                                element={<LegacyOpCodeRedirect />}
                                            />
                                        </Route>
                                        {/* Channel Builder */}
                                        <Route path="channels">
                                            <Route index element={<Channels />} />
                                            <Route path=":channelId" element={<ChannelDetails />} />
                                        </Route>
                                        <Route path="ai-lab" element={<AiLabWrapper />}>
                                            <Route index element={<AiLab />} />
                                            <Route path="instructions">
                                                <Route index element={<Instructions />} />
                                                <Route
                                                    path=":uniqueName/:modelType"
                                                    element={<InstructionDetails />}
                                                ></Route>
                                            </Route>
                                            <Route path="prompt-lab" element={<LivePrompt />} />
                                            <Route path="api-manager" element={<ApiManager />} />
                                            <Route path="mcp-builder" element={<MCPManager />} />
                                            <Route path="code-sandbox" element={<CodeSandbox />} />
                                            <Route path="ai-teacher" element={<AITeacher />} />
                                            <Route path="tuning-lab" element={<TuningExperiment />} />
                                            <Route
                                                path="instruction-vnv"
                                                element={<InstructionVnV />}
                                            />
                                        </Route>
                                        <Route
                                            path="settings"
                                            element={<SubOrganizationSettings />}
                                        />
                                        {/* DE Studio — A-0012.02 (gated by DE_STUDIO_ENABLED flag) */}
                                        {DE_STUDIO_ENABLED && (
                                            <Route path="de-studio" element={<DEStudioShell />}>
                                                {/* Skip the mode-select gate — go straight to Advanced (unified builder). */}
                                                <Route index element={<Navigate to="unified-builder" replace />} />
                                                <Route path="unified-builder" element={<UnifiedBuilder />} />
                                                <Route path="unified-builder/:assistantId" element={<AssistantWorkspace />} />
                                                <Route path="library" element={<LibraryPage />} />
                                                <Route path="library/opcode/:opcodeId" element={<LibraryOpcodeRedirect />} />
                                                {/* Legacy library sub-builders use relative navigation when the user
                                                    clicks an item: 2-segment for instructions, 1-segment for channels.
                                                    Mirror the legacy ai-lab routes here so the URL resolves. */}
                                                <Route path="library/:uniqueName/:modelType" element={<InstructionDetails />} />
                                                <Route path="library/:channelId" element={<ChannelDetails />} />
                                                {/* KB collection editor — mirrors the legacy `knowledge-builder/:collectionId/:fileName`
                                                    so DSCollectionsList click resolves cleanly inside DE Studio.
                                                    KBFileManager uses `flex-grow / h-full` internally, so it needs a
                                                    flex-height parent or the folder list collapses to 0px. */}
                                                <Route
                                                    path="knowledge/:collectionId/:fileName"
                                                    element={
                                                        <div className="flex h-full w-full">
                                                            <KBFileManager />
                                                        </div>
                                                    }
                                                />
                                                <Route path="channels">
                                                    <Route index element={<Channels />} />
                                                    <Route path=":channelId" element={<ChannelDetails />} />
                                                </Route>
                                                <Route path="activity" element={<ActivityPage />} />
                                                <Route path="usage" element={<UsagePage />} />
                                                <Route path="knowledge" element={<LibraryCollectionsRedirect />} />
                                            </Route>
                                        )}
                                    </Route>
                                </Route>
                            </Route>
                        </Route>
                    </Route>
                </Route>

                <Route path="verify-email" element={<VerifyEmail />} />

                {/* Not Found */}
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}

const LegacyOpCodeRedirect = () => {
    const {
        opCodeName
    } = useParams();

    return <Navigate to={`v2/${opCodeName}`} replace />;
};

/**
 * Tier 1 of the error-boundary stack (app root).
 *
 * React 18 unmounts the entire tree on an uncaught render error, so without
 * this the user gets a blank white page with no shell, no navigation and no
 * way back except a manual refresh. Wrapping the export instead of the
 * <Routes> body keeps this a two-line change and still catches everything
 * App renders. Tiers 2 (per route) and 3 (per builder panel) sit below and
 * catch first — this one only ever fires for a failure above the layouts.
 */
export default function AppWithErrorBoundary() {
    return (
        <AppErrorBoundary>
            <App />
        </AppErrorBoundary>
    );
}
